module.exports = __webpack_public_path__ + "img/obs_water_flood.5519278f.svg";